var map = {
	"./ICBKCNBJXXX.png": "697d",
	"./UnionPay.png": "0514",
	"./alipay.png": "82ba",
	"./alipay_wap.png": "90fb",
	"./allscore.png": "c0d1",
	"./btcsmzf.png": "3599",
	"./chinaway.png": "28b1",
	"./chinaway_scanpay.png": "5ae6",
	"./ivi_dcbox.png": "b235",
	"./ivi_electronic.png": "361b",
	"./micrpay.png": "fb25",
	"./other.png": "813e",
	"./paycoat.png": "0123",
	"./unionscanpay.png": "b2fe",
	"./usdtsmzf.png": "995c",
	"./wechatpay.png": "f22b",
	"./wechatpay_wap.png": "58f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "237c";